module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form-group', {
    attrs: {
      "label": _vm.label,
      "id": _vm.elementId,
      "cols": _vm.cols,
      "wrapped": _vm.wrapped,
      "error-message": _vm.errorMessage
    }
  }, [_c('textarea', {
    ref: "textarea",
    staticClass: "form-control",
    style: (_vm.styles),
    attrs: {
      "id": _vm.elementId,
      "rows": _vm.rows,
      "cols": _vm.cols,
      "maxlength": _vm.maxLength,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.mask.format ? _vm.masked : _vm.value
    },
    on: {
      "input": _vm.updateModel,
      "keypress": _vm.preventKeys
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0c7b9031", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c7b9031"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/components/form/textarea.vue
// module id = 410
// module chunks = 1